module.exports = __webpack_public_path__ + "img/item_Portrait_04.32ad7129.jpeg";